import { useState, useEffect, useRef } from "react";
import UAParser from "ua-parser-js";
import {
  offerEvent,
  getContestQuestion,
  submitQuestions,
  fetchIpAddress,
  getAdvertisements,
} from "../../../utils/api";
import { v4 as uuidv4 } from "uuid";
import style from "../css/RandomQuestions.module.css";
import { ErrorHandling } from "../../../State";
import Header from "./Header";
import { Link } from "react-router-dom";

import fpCoin from "../../../icons/coin.svg";

import { AnimatePresence, motion } from "framer-motion";

import { useNavigate, useLocation } from "react-router-dom";
import { fanduBannerImgUrl } from "../../../utils/config";
import SubmitUserDetails from "../../Login/component/SubmitUserDetails";
import MathGame from "./MathGame";
import NumberRain from "./NumberRain";
import ColorMatchGame from "./ColorMatchGame";

function RandomQuestions() {
  const [questions, setQuestions] = useState([]);
  const [category, setCategory] = useState("");
  const [quizId, setQuizId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [ipAddress, setIpAddress] = useState("");
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(() => {
    const savedIndex = localStorage.getItem("quizCurrentQuestionIndex");
    return savedIndex ? Number(savedIndex) : 0;
  });
  const [selectedOption, setSelectedOption] = useState(null);
  const [userAnswers, setUserAnswers] = useState([]);
  const [batchAnswers, setBatchAnswers] = useState([]);
  const [batchCount, setBatchCount] = useState(0);
  const [showLoginPage, setShowLoginPage] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [isSubmittingTransition, setIsSubmittingTransition] = useState(false);
  const [showSubmitButton, setShowSubmitButton] = useState(false);
  const [adData, setAdData] = useState(null);

  const [showAdvertisement, setShowAdvertisement] = useState(false);
  const [currentAd, setCurrentAd] = useState(null);
  const [bannerData, setBannerData] = useState(null);
  const [showSubmitPopup, setShowSubmitPopup] = useState(false);
  const [earnedScore, setEarnedScore] = useState(0);

  const [showGamePopup, setShowGamePopup] = useState(false);
  const [currentGame, setCurrentGame] = useState(null);
  const [questionsPlayed, setQuestionsPlayed] = useState(0);
  const [gameInProgress, setGameInProgress] = useState(false);

  const [page, setPage] = useState(1);
  const [isFetchingNextPage, setIsFetchingNextPage] = useState(false);

  const lastGameShownRef = useRef(0);

  const games = ["math1", "math2", "color"];

  const closeGame = () => {
    setShowGamePopup(false);
    setCurrentGame(null);
    setGameInProgress(false);
    moveNextQuestion();
  };

  const showRandomGame = () => {
    console.log("SHOW GAME");
    // const randomGame = games[Math.floor(Math.random() * games.length)];
    const randomGame = games[Math.floor(Math.random() * games.length)];
    avail2("Fun_Game", "Quiz_Feed", "Click", "Screen_Impressions");
    setGameInProgress(true);
    setCurrentGame(randomGame);
    setShowGamePopup(true);
  };

  const handleGameClose = () => {
    avail2("Fun_Game_Close", "Quiz_Feed", "Click", "Screen_Impressions");
    closeGame();
  };

  let mId = localStorage.getItem("mId") || "2026";
  let uuid = localStorage.getItem("uuid");

  const [fanduUserId, setFanduUserId] = useState(
    localStorage.getItem("fanduUserId"),
  );

  const showRandomAdvertisement = () => {
    if (!bannerData?.length) return;

    const banner = bannerData[Math.floor(Math.random() * bannerData.length)];

    setCurrentAd(banner);
    setShowAdvertisement(true);

    avail2(
      "Quiz_Ad_Banner",
      "Screen_Impressions",
      "Page_Open",
      "Advertisement_Banner",
    );
  };

  const handleCloseAdvertisement = () => {
    setShowAdvertisement(false);
    moveNextQuestion();
  };

  const generateUUIDUsingMachineId = (machineId) => {
    try {
      const generatedUUID = uuidv4();

      return `${generatedUUID.substring(0, 24)}${(machineId || "").substring(
        0,
        12,
      )}`;
    } catch (error) {
      ErrorHandling("Unable to generate device identifier");
      return uuidv4();
    }
  };

  const generateSessionId = () => {
    try {
      let sessionId = localStorage.getItem("session_id");

      if (!sessionId) {
        const uuid = uuidv4();
        const timestamp = Date.now();

        sessionId = `${uuid.substring(0, 24)}${mId.substring(0, 12)}-${timestamp}`;

        localStorage.setItem("session_id", sessionId);
      }

      return sessionId;
    } catch (error) {
      console.log(error);
      return "";
    }
  };

  try {
    if (!uuid) {
      uuid = generateUUIDUsingMachineId(mId);
      localStorage.setItem("uuid", uuid);
    }
  } catch (error) {
    ErrorHandling("Unable to initialize application");
  }

  useEffect(() => {
    try {
      // localStorage.removeItem("selectedAnswers");
      localStorage.removeItem("cartAmount");
      localStorage.removeItem("cartQty");
      localStorage.removeItem("rewardKey");
      localStorage.removeItem("selectedQuizCategory");
      localStorage.removeItem("order_id");
      localStorage.removeItem("order_session_id");
      localStorage.removeItem("vendify_order_id");
    } catch (error) {
      console.log("LocalStorage Cleanup Error:", error);
    }
  }, []);

  const getIpAddress = async () => {
    try {
      const data = {
        device_id: uuid || "",
        session_id: generateSessionId() || "",
        user_id: localStorage.getItem("userId") || "",
        machine_id: mId || "",
      };

      const response = await fetchIpAddress(data);

      if (response?.ip_address) {
        setIpAddress(response.ip_address);
        localStorage.setItem("ip_address", response.ip_address);
      } else {
        ErrorHandling("Unable to fetch IP address");
      }
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Failed to fetch IP address",
      );
    }
  };

  const fetchData = async (pageNumber = 1, append = false) => {
    if (isFetchingNextPage) return;

    if (pageNumber === 1) {
      setLoading(true);
    } else {
      setIsFetchingNextPage(true);
    }

    try {
      const response = await getContestQuestion(pageNumber);

      if (response?.success && response?.data?.questions?.length > 0) {
        localStorage.setItem("quizId", response.data.questions[0].quiz_id);
        if (append) {
          setQuestions((prev) => [...prev, ...response.data.questions]);
        } else {
          setQuestions(response.data.questions);
          setQuizId(response.data.id);
          setCategory(response.data.quiz.Category.name);
        }
      }
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to load quiz questions",
      );
    } finally {
      if (pageNumber === 1) {
        setLoading(false);
      } else {
        setIsFetchingNextPage(false);
      }
    }
  };

  const offerRequestData = (eventMetaData) => {
    try {
      const parser = new UAParser();
      const result = parser.getResult();

      return {
        machine_id: mId || "",
        device_id: uuid || "",
        session_id: generateSessionId() || "",
        user_id: localStorage.getItem("userId") || "",
        ip_address: ipAddress || "",
        lat: "",
        lng: "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
        firstname: "",
        lastname: "",
        email: "",
        phone: "",
        deviceBrand: result?.device?.vendor || "Unknown",
        deviceModel: result?.device?.model || "Unknown",
        deviceType: result?.device?.type || "desktop",
        osName: result?.os?.name || "Unknown",
        osVersion: result?.os?.version || "Unknown",
        browserName: result?.browser?.name || "Unknown",
        browserVersion: result?.browser?.version || "Unknown",
        event_ts: Date.now().toString(),
        ...eventMetaData,
      };
    } catch (error) {
      ErrorHandling("Unable to collect device details");
      return null;
    }
  };

  const avail = async (currentIndex, quiz_id, qs_id) => {
    try {
      if (!quiz_id || !qs_id) {
        console.warn("Missing quiz_id or qs_id", {
          quiz_id,
          qs_id,
        });

        return;
      }

      const eventMetaData = {
        Event_Name: category,
        Event_Sub_Name: "Quiz",
        Event_Type: "Click",
        Event_Sub_Type: `Q${currentIndex + 1}`,
        Event_MetaData: {
          quiz_id: quiz_id,
          qs_id: qs_id,
        },
      };

      const requestData = offerRequestData(eventMetaData);

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to save quiz activity",
      );
    }
  };

  const avail2 = async (eventScreen, eventSubName, eventType, eventSubType) => {
    try {
      const eventMetaData = {
        Event_Name: eventScreen,
        Event_Sub_Name: eventSubName,
        Event_Type: eventType,
        Event_Sub_Type: eventSubType,
      };

      const requestData = offerRequestData(eventMetaData);

      if (!requestData) return;

      await offerEvent(requestData);
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to process analytics event",
      );
    }
  };

  async function fetchAdvertisement() {
    try {
      const response = await getAdvertisements(5);
      if (response.success) setAdData(response.data[0].items);
    } catch (error) {
      ErrorHandling(error?.message || "Unable to fetch data");
    }
  }

  async function fetchAdvertisementBanner() {
    try {
      const response = await getAdvertisements(6);
      if (response.success) setBannerData(response.data[0].items);
    } catch (error) {
      ErrorHandling(error?.message || "Unable to fetch data");
    }
  }

  useEffect(() => {
    fetchData(1);
    fetchAdvertisement();
    fetchAdvertisementBanner();

    const initializeData = async () => {
      try {
        const storedIp = localStorage.getItem("ip_address");

        if (!storedIp || storedIp.trim() === "") {
          await getIpAddress();
        } else {
          setIpAddress(storedIp);
        }
      } catch (error) {
        ErrorHandling(error?.message || "Unable to initialize quiz data");
      }
    };

    initializeData();
  }, []);

  useEffect(() => {
    if (
      questions.length > 0 &&
      currentQuestionIndex > 0 &&
      currentQuestionIndex < 99 &&
      (currentQuestionIndex + 2) % 20 === 0 &&
      questions.length < 100
    ) {
      const nextPage = page + 1;

      fetchData(nextPage, true);
      setPage(nextPage);
    }
  }, [currentQuestionIndex, questions.length, page]);

  useEffect(() => {
    avail2("Quiz", "Screen_Impressions", "Page_Open", "Questions");
    if (showLogin || showLoginPage) {
      avail2("Login", "Screen_Impressions", "Page_Open", "Submit_User_Details");
    }
  }, [showLogin, showLoginPage]);

  useEffect(() => {
    setSelectedOption(null);
  }, [currentQuestionIndex]);

  const currentQuestion = questions[currentQuestionIndex];

  const handleQuestionProgress = () => {
    const totalPlayed = questionsPlayed + 1;

    setQuestionsPlayed(totalPlayed);

    if (totalPlayed % 4 === 0) {
      showRandomAdvertisement();
      return;
    }

    moveNextQuestion();
  };

  const handleOptionClick = async (optionIndex) => {
    try {
      if (!currentQuestion || selectedOption !== null) return;

      const selectedOptionId = currentQuestion.question_options[optionIndex].id;

      // Analytics
      await avail(currentQuestionIndex, quizId, currentQuestion.id);

      const answerData = {
        question_id: currentQuestion.id,
        selected_option_id: selectedOptionId,
      };

      const updatedBatch = [...batchAnswers, answerData];

      setBatchAnswers(updatedBatch);
      setUserAnswers((prev) => [...prev, answerData]);
      setSelectedOption(optionIndex);

      setTimeout(() => {
        const newBatchCount = batchCount + 1;

        setBatchCount(newBatchCount);

        if (newBatchCount >= 5) {
          setShowSubmitButton(true);
        }

        // After every 5 answered questions
        const payload = {
          user_id: fanduUserId || "",
          quiz_id: localStorage.getItem("quizId"),
          responses: updatedBatch,
        };

        localStorage.setItem("selectedAnswers", JSON.stringify(payload));
        if (newBatchCount === 5) {
          const existingUser = localStorage.getItem("fanduUserId");

          if (!existingUser) {
            setShowLogin(true);
            return;
          }

          autoSubmitQuiz(payload);
          return;
        }

        avail2(
          "Quiz",
          `Question ${currentQuestionIndex + 1}`,
          "Click",
          "Questions",
        );

        handleQuestionProgress();

        // moveNextQuestion();

        // const nextPlayed = questionsPlayed + 1;
        // if (nextPlayed % 4 === 0) {
        //   showRandomAdvertisement();
        // } else {
        //   moveNextQuestion();
        // }
      }, 450);
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to save selected answer",
      );
    }
  };

  const moveNextQuestion = () => {
    setSelectedOption(null);

    setCurrentQuestionIndex((prev) => {
      if (prev >= 99) {
        localStorage.removeItem("quizCurrentQuestionIndex");
        return prev;
      }

      const nextIndex = prev + 1;

      localStorage.setItem("quizCurrentQuestionIndex", nextIndex.toString());

      return nextIndex;
    });
  };

  const autoSubmitQuiz = async (payload) => {
    try {
      const response = await submitQuestions(payload);

      if (response?.success) {
        const data = response?.data || [];

        const correct = data.filter((item) => item.is_correct).length;

        const pointsEarned = response.quiz_score;

        localStorage.setItem("correctAnswers", correct);

        const newPoints = Number(response.total_score || 0);

        localStorage.setItem("userFanduPoints", newPoints);

        // reset batch
        setBatchCount(0);
        setBatchAnswers([]);

        // localStorage.removeItem("selectedAnswers");
        setEarnedScore(pointsEarned);
        setShowSubmitPopup(true);

        setTimeout(() => {
          setShowSubmitPopup(false);
        }, 3000);

        // load next questions
        moveNextQuestion();
      }
    } catch (error) {
      ErrorHandling(
        error?.response?.data?.message ||
          error?.message ||
          "Unable to submit quiz",
      );
    }
  };

  useEffect(() => {
    setShowSubmitButton(batchAnswers.length > 0);
  }, [batchAnswers]);

  const handleSkipQuestion = () => {
    try {
      if (!currentQuestion) return;

      // move to next question without saving answer
      if (currentQuestionIndex < questions.length - 1) {
        setCurrentQuestionIndex((prev) => prev + 1);
        setSelectedOption(null);
      } else {
        // last question
        const finalPayload = {
          user_id: localStorage.getItem("userId") || "",
          quiz_id: quizId,
          responses: userAnswers,
        };

        localStorage.setItem("selectedAnswers", JSON.stringify(finalPayload));

        handleQuestionProgress();
      }
    } catch (error) {
      ErrorHandling(error?.message || "Unable to skip question");
    }
  };

  if (loading) {
    return (
      <div className={style.loaderWrapper}>
        <div className={style.loader}></div>
      </div>
    );
  }

  const handleLoginSkip = () => {
    setShowLogin(false);
    setShowLoginPage(false);
    setBatchCount(0);
    setBatchAnswers([]);
    moveNextQuestion();
  };

  const handleLoginSubmit = () => {
    setFanduUserId(localStorage.getItem("fanduUserId"));

    setBatchCount(0);
    setBatchAnswers([]);

    localStorage.removeItem("selectedAnswers");

    // Trigger upward animation
    setIsSubmittingTransition(true);
  };

  // const handleLoginSubmit = () => {
  //   setShowLogin(false);
  //   setShowLoginPage(false);
  //   setFanduUserId(localStorage.getItem("fanduUserId"));
  //   setBatchCount(0);
  //   setBatchAnswers([]);
  //   localStorage.removeItem("selectedAnswers");
  //   moveNextQuestion();
  // };

  const handleSubmitClick = async () => {
    const existingUser = localStorage.getItem("fanduUserId");

    // User has never submitted before
    if (!existingUser) {
      setShowLoginPage(true);
      return;
    }

    // Nothing to submit
    if (batchAnswers.length === 0) {
      ErrorHandling("Please answer at least one question");
      return;
    }

    const payload = {
      user_id: existingUser,
      quiz_id: localStorage.getItem("quizId"),
      responses: batchAnswers,
    };

    await autoSubmitQuiz(payload);
  };

  const fanduPoints = localStorage.getItem("userFanduPoints") || "0";

  return (
    <>
      <div className={style.page}>
        {/* {!showLoginPage && !showLogin && ( */}
        <Header
          title="noArrow"
          path={`/vm/${mId}/`}
          fanduPoints={fanduPoints}
        />
        {/* )} */}
        <div className={style.questionScreen}>
          {/* {!showLoginPage && !showLogin && ( */}
          <SoftHeader
            onNavigate={handleSubmitClick}
            showSubmit={showSubmitButton}
          />
          {/* )} */}
          <div className={style.viewport}>
            <AnimatePresence mode="sync">
              <motion.div
                key={`${showLogin || showLoginPage ? "login" : "question"}-${currentQuestionIndex}`}
                initial={{ y: "100%" }}
                animate={{
                  y: isSubmittingTransition ? "-100%" : 0,
                }}
                exit={{ y: "-100%" }}
                transition={{
                  duration: 1,
                  ease: [0.22, 1, 0.36, 1],
                }}
                onAnimationComplete={() => {
                  if (isSubmittingTransition) {
                    setShowLogin(false);
                    setShowLoginPage(false);

                    setIsSubmittingTransition(false);

                    moveNextQuestion();
                  }
                }}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                }}
                drag="y"
                dragConstraints={{
                  top: -120,
                  bottom: 0,
                }}
                dragElastic={0.25}
                onDragEnd={(event, info) => {
                  if (info.offset.y < -80) {
                    if (showLogin || showLoginPage) {
                      setShowLogin(false);
                      setShowLoginPage(false);

                      setBatchCount(0);
                      setBatchAnswers([]);

                      moveNextQuestion();
                      return;
                    }

                    if (showGamePopup) {
                      closeGame();
                      return;
                    }

                    if (showAdvertisement) {
                      setShowAdvertisement(false);
                      setCurrentAd(null);

                      moveNextQuestion();
                      return;
                    }

                    handleSkipQuestion();
                  }
                }}
              >
                {/* <motion.div
                key={`${showLogin || showLoginPage ? "login" : "question"}-${currentQuestionIndex}`}
                initial={{ y: "100%" }}
                animate={{ y: 0 }}
                exit={{ y: "-100%" }}
                transition={{
                  duration: 1,
                  ease: [0.22, 1, 0.36, 1],
                }}
                style={{
                  position: "absolute",
                  inset: 0,
                  width: "100%",
                }}
                drag="y"
                dragConstraints={{
                  top: -120,
                  bottom: 0,
                }}
                dragElastic={0.25}
                onDragEnd={(event, info) => {
                  if (info.offset.y < -80) {
                    if (showLogin || showLoginPage) {
                      setShowLogin(false);
                      setShowLoginPage(false);

                      setBatchCount(0);
                      setBatchAnswers([]);

                      moveNextQuestion();
                      return;
                    }

                    if (showGamePopup) {
                      closeGame();
                      return;
                    }

                    if (showAdvertisement) {
                      setShowAdvertisement(false);
                      setCurrentAd(null);

                      moveNextQuestion();
                      return;
                    }

                    handleSkipQuestion();
                  }
                }}
              > */}
                {showLogin || showLoginPage ? (
                  <SubmitUserDetails
                    onSubmit={handleLoginSubmit}
                    onSkip={handleLoginSkip}
                    isNavigate={true}
                  />
                ) : showAdvertisement ? (
                  <AdvertisementScreen
                    banner={currentAd}
                    onClose={handleCloseAdvertisement}
                    avail2={avail2}
                  />
                ) : showGamePopup ? (
                  <>
                    {currentGame === "math1" && (
                      <MathGame autoStart onClose={handleGameClose} />
                    )}

                    {currentGame === "math2" && (
                      <NumberRain autoStart onClose={handleGameClose} />
                    )}

                    {currentGame === "color" && (
                      <ColorMatchGame autoStart onClose={handleGameClose} />
                    )}
                  </>
                ) : (
                  <QuestionScreen
                    currentQuestion={currentQuestion}
                    selectedOption={selectedOption}
                    handleOptionClick={handleOptionClick}
                    adData={adData}
                    avail2={avail2}
                    currentQuestionIndex={currentQuestionIndex}
                  />
                )}
              </motion.div>
            </AnimatePresence>
          </div>
          {showSubmitPopup && (
            <div className={style.popupOverlay}>
              <div className={style.submitPopup}>
                <div className={style.successIcon}>🎉</div>

                <h3>Quiz Submitted!</h3>

                {earnedScore > 0 && (
                  <div className={style.score}>
                    +{earnedScore} <img src={fpCoin} alt="" />
                  </div>
                )}

                <span>Your responses have been saved successfully.</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default RandomQuestions;

const QuestionScreen = ({
  currentQuestion,
  selectedOption,
  handleOptionClick,
  adData,
  avail2,
  currentQuestionIndex,
}) => {
  const navigate = useNavigate();
  const [showExitPopup, setShowExitPopup] = useState(false);
  const [selectedBanner, setSelectedBanner] = useState(null);

  const questionThemes = [
    {
      card: "linear-gradient(180deg, #23003B, #42005D)",
      accent: "#FF4D8D",
    },
    {
      card: "linear-gradient(180deg, #003B2E, #00664F)",
      accent: "#2DD4BF",
    },
    {
      card: "linear-gradient(180deg, #3B2300, #7A4B00)",
      accent: "#F59E0B",
    },
    {
      card: "linear-gradient(180deg, #0B2E6B, #1E4ED8)",
      accent: "#60A5FA",
    },
    {
      card: "linear-gradient(180deg, #5B0023, #A10045)",
      accent: "#F472B6",
    },
    {
      card: "linear-gradient(180deg, #2E1065, #5B21B6)",
      accent: "#A78BFA",
    },
  ];

  const theme = questionThemes[currentQuestionIndex % questionThemes.length];
  const [randomBanner, setRandomBanner] = useState(null);

  useEffect(() => {
    if (adData?.length) {
      const banner = adData[Math.floor(Math.random() * adData.length)];
      setRandomBanner(banner);
    }
  }, [currentQuestionIndex, adData]);
  return (
    <>
      <div className={style.bannerSection}>
        <img
          src={`${fanduBannerImgUrl}/${currentQuestion?.Category?.banner_img}`}
          className={style.banner}
          alt=""
        />
      </div>
      <div className={style.bottomSection}>
        <div className={style.rewardBanner}>
          <img src={fpCoin} alt="" />
          <span>1 point for each question.</span>
        </div>

        <div
          className={style.questionCard}
          style={{
            background: theme.card,
          }}
        >
          <h2 className={style.questionText}>
            {currentQuestion?.question_text}
          </h2>

          <div className={style.options} style={{ color: theme.accent }}>
            {currentQuestion?.question_options?.map((option, index) => (
              <div
                key={index}
                className={`${style.option}
            ${selectedOption === index ? style.selected : ""}`}
                onPointerDown={(e) => e.stopPropagation()}
                onClick={() => handleOptionClick(index)}
              >
                <div
                  style={{ backgroundColor: theme.accent }}
                  className={`${style.optionLetter}
                  
            ${selectedOption === index ? style.selectedChar : style.nonSelectChar}`}
                >
                  {String.fromCharCode(65 + index)}
                </div>

                <span>{option.option_text}</span>

                {selectedOption === index && (
                  <div className={style.tick}>✓</div>
                )}
              </div>
            ))}
          </div>
        </div>

        {randomBanner && (
          <img
            src={`${fanduBannerImgUrl}${randomBanner.image_url}`}
            alt={randomBanner.title}
            style={{ marginTop: "10px", borderRadius: "12px", width: "100%" }}
            onClick={() => {
              avail2(
                "Quiz_Ad_Banner",
                "Screen_Impressions",
                "Click",
                "Advertisement_Banner",
              );

              setSelectedBanner(randomBanner);
              setShowExitPopup(true);
            }}
          />
        )}
      </div>
      {showExitPopup && (
        <div className={style.popupOverlay}>
          <div className={style.exitPopup}>
            <h3>Leave Quiz?</h3>

            <p>Submit your quiz before leaving to save your earned points.</p>

            <div className={style.popupButtons}>
              <button
                className={style.cancelBtn}
                onClick={() => {
                  navigate();
                  setShowExitPopup(false);
                  avail2(
                    "Stay",
                    "Screen_Impressions",
                    "Click",
                    "Advertisement_Banner",
                  );
                }}
              >
                Stay
              </button>
              <Link to={selectedBanner.redirection_url}>
                <button
                  className={style.leaveBtn}
                  onClick={() => {
                    setShowExitPopup(false);
                    avail2(
                      "Leave",
                      "Screen_Impressions",
                      "Click",
                      "Advertisement_Banner",
                    );
                  }}
                >
                  Leave Anyway
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export const SoftHeader = ({ onNavigate, showSubmit }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const tabs = [
    { label: "Quiz", path: "/quiz-questions" },
    { label: "Hot Deals", path: "/hot-deals" },
    { label: "Rewards", path: "/rewards" },
    { label: "Games", path: "/quiz-categories" },
    { label: "Offers", path: "/fandu-offers" },
  ];

  return (
    <div className={style.softHeader}>
      <ul className={style.routes}>
        {tabs.map((tab) => (
          <li
            key={tab.label}
            className={location.pathname === tab.path ? style.activeTab : ""}
            onClick={() => navigate(tab.path)}
          >
            {tab.label}
          </li>
        ))}
      </ul>

      {showSubmit && (
        <div className={style.submitButton} onClick={onNavigate}>
          Submit
        </div>
      )}
    </div>
  );
};

const AdvertisementScreen = ({ banner, onClose, avail2 }) => {
  const navigate = useNavigate();

  // if (!banner) return null;

  return (
    <Link className={style.adScreen} to={`${banner.redirection_url}`}>
      <img
        // src={ad}
        src={`${fanduBannerImgUrl}/${banner.image_url}`}
        className={style.fullScreenAd}
        onClick={() => {
          avail2(
            "Quiz_Ad_Banner",
            "Quiz_Questions",
            "Click",
            "Advertisement_Banner",
          );

          // navigate(`app.punnyadhara.com${banner.redirection_url}`);
        }}
      />

      {/* <button className={style.skipAd} onClick={onClose}>
        Continue →
      </button> */}
    </Link>
  );
};
